define('app/views/checkout_shipping_container_view',['app/setup'], function(takhfifan) {
  takhfifan.checkoutShippingContainerView = Backbone.View.extend({
    events: {
      'click .tkh-shipping-prev-btn': 'back',
    },

    initialize: function(options) {
      var _this = this;
      _this.backToLogin = false;
      _this.backToGuestAddress = false;
      _this.isGuest = _this.$el.data('isguest');
      takhfifan.eventHub.on('checkout:shipping', function() {
       _this.$el.show();
      });
      takhfifan.eventHub.on('guest_customer_info:saved', function(data) {
       _this.$('.address-list').hide();
       _this.backToLogin = true;
      });
      takhfifan.eventHub.on('shipping:method_updated', function(data) {
        _this.backToGuestAddress = true;
        _this.backToLogin = false;
      });
    },
    back: function(evt) {
      var _this = this;
      if(_this.backToLogin) {
        evt.preventDefault();
        takhfifan.eventHub.trigger('checkout:login', {});
        _this.guestAddressSubmitted = false;
      }
      else if(_this.backToGuestAddress && _this.isGuest) {
        takhfifan.eventHub.trigger('checkout:guestaddress', {});
        _this.backToLogin = true;
        _this.guestAddressSubmitted = false;
      }
      else {
        if(!_.isUndefined($(evt.target).data('href'))) {
          window.location.href = $(evt.target).data('href');
        }
        else {
          window.location.href = $(evt.target).parent().data('href');
        }
      }
    }
  });
});

